export default __webpack_public_path__ + "static/media/add-template-white.c4e59938.svg";